import { round } from 'lodash';
import { AXIS_LABEL_FONT_SIZE } from './constants';

export const PDF_LABEL_FONT_SIZE = 6;

export const PDF_LABEL_SCALE = PDF_LABEL_FONT_SIZE / AXIS_LABEL_FONT_SIZE;

export const scalePdfLayoutMetric = (portalValue: number) =>
  round(portalValue * PDF_LABEL_SCALE, 2);
